<div class="ph-team-picker-sheet">

    <!-- Handle -->
    <div class="flex justify-center pt-3 pb-1">
        <div class="w-10 h-1 rounded-full bg-gray-300"></div>
    </div>

    <!-- Title -->
    <div class="px-6 pt-3 pb-2">
        <p class="text-xs font-semibold uppercase tracking-wider text-gray-400">
            {{ 'teamSwitcher.title' | transloco }}
        </p>
    </div>

    <!-- Flat team list -->
    <ul class="pb-6">
        @for (team of allTeams; track team.id) {
            <li>
                <button
                    class="flex w-full items-center gap-3 px-6 py-3 text-left transition-colors active:bg-gray-50"
                    [class.bg-indigo-50]="team.id === selectedId"
                    (click)="select(team.id)">

                    <!-- Team squircle (identity color, not selection state) -->
                    <span
                        class="flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-[13px] text-white font-extrabold text-sm shadow-[inset_0_0_0_1px_rgba(255,255,255,0.14)]"
                        [class]="teamColorClass(team)">
                        {{ team.initials }}
                    </span>

                    <!-- Name + meta -->
                    <div class="flex flex-col flex-1 min-w-0 leading-snug">
                        <p class="truncate text-[15px] font-semibold"
                           [class.text-indigo-700]="team.id === selectedId"
                           [class.text-gray-800]="team.id !== selectedId">
                            {{ team.name }}
                        </p>
                        <p class="truncate text-xs text-gray-400">
                            {{ team.leagueName }} &middot; {{ team.category }}
                        </p>
                    </div>

                    <!-- Check on selected -->
                    @if (team.id === selectedId) {
                        <mat-icon class="shrink-0 text-indigo-600 ph-icon-22">
                            check
                        </mat-icon>
                    }

                </button>
            </li>
        }
    </ul>


</div>
